import './how-we-work.css';

const HowWeWork = () => {

    return(

        <div className="how-it-works">

            <div className="steps1">
                <div className="step1">
                    <div className="icon-wrapper">
                        <div className="step-number">1</div>
                        <div className="icon">📞</div>
                    </div>
                    <h3>Send Photos or Call</h3>
                    <p>Tell us your job list.</p>
                </div>

                <div className="step1">
                    <div className="icon-wrapper">
                        <div className="step-number">2</div>
                        <div className="icon">📋</div>
                    </div>
                    <h3>Get a Clear Quote</h3>
                    <p>Get your fair, upfront quote.</p>
                </div>

                <div className="step1">
                    <div className="icon-wrapper">
                        <div className="step-number">3</div>
                        <div className="icon">✔️</div>
                    </div>
                    <h3>Book & Get Done Fast</h3>
                    <p>Done right the first time.</p>
                </div>
            </div>
        </div>
    )
}

export default HowWeWork;